import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore, displayRole } from '../stores/auth-store';
import { ErrorBoundary } from './ErrorBoundary';

export function Layout() {
  const { user, logout } = useAuthStore();
  const loc = useLocation();
  const nav = useNavigate();

  const links = [
    { to: '/opportunities', label: 'Opportunities' },
    { to: '/saved-searches', label: 'Saved searches' },
  ];
  if (user?.role === 'ADMIN') {
    links.push({ to: '/admin/sources', label: 'Sources' });
    links.push({ to: '/admin/coverage', label: 'Coverage' });
    links.push({ to: '/admin/users', label: 'Users' });
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-brand-navy text-white shadow">
        <div className="max-w-6xl mx-auto flex items-center px-6 py-3">
          <Link to="/opportunities" className="font-bold text-xl">
            Plan<span className="text-brand-gold">Grab</span>
          </Link>
          <nav className="flex items-center gap-4 ml-8">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`px-2 py-1 rounded text-sm ${loc.pathname === l.to ? 'bg-white/15 font-semibold' : 'hover:bg-white/10'}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm">
            <span className="text-slate-300">{user?.email}</span>
            <span className="px-2 py-0.5 rounded bg-brand-gold/20 text-brand-gold text-xs">
              {displayRole(user?.role)}
            </span>
            <button
              onClick={async () => { await logout(); nav('/login'); }}
              className="px-3 py-1 rounded bg-white/10 hover:bg-white/20 text-sm"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-6">
        {/* A crashing page renders a recoverable fallback here with the
            nav/header intact; resetKey={pathname} clears it on navigation so
            the error doesn't stick when you move to another tab. */}
        <ErrorBoundary resetKey={loc.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
